import { Component, OnInit } from '@angular/core';
import { MetricsService } from '../../shared/metrics.service';
import { EChartsOption } from 'echarts';

@Component({
    selector: 'app-kevlar2-progress',
    templateUrl: './kevlar2-progress.component.html',
    styleUrls: ['./kevlar2-progress.component.scss'],
    standalone: false
})
export class Kevlar2ProgressComponent implements OnInit {
  isLoading = true;
  hi;
  countAp63Remediations: any = 0;
  all61Fs: any = [];
  all61FsKevlar2: any = [];
  allMS210s: any = [];
  allMS210sKevlar2: any = [];
  sitesRefreshed: any = [];
  sitesRefreshed2024: any = [];
  countSitesRefreshedRemodels2023: any = 0;
  countSitesRefreshedRemodels2024: any = 0;
  totalSites: number = 0;
  monthYearCountsTuple: any = [];
  ytdRefreshesOption: any = null;
  PLANNED_REFRESHES_2024 = 1350;
  MONTHS = {
    '01': 'January',
    '02': 'February',
    '03': 'March',
    '04': 'April',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'August',
    '09': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December'
  };
  // fortinetsOption: EChartsOption;
  //
  // fortinetAvailCurrentMonth;
  //
  // fortinetAvgOfflineEventsPerDay;

  constructor(
    private metricsService: MetricsService
  ) {}

  getHi() {
    const promise = new Promise((resolve) => {
      this.metricsService.getMetricsHi().then(response => {
        response.toPromise().then(response => {
          try {
            // console.log(response)
            this.hi = response["message"].hi
          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });
  }

  generateYTDRefreshesChart() {
    // const promise = new Promise((resolve) => {
    //   this.metricsService.getFortinetAvailabilityOrg().then(response => {
    //     response.toPromise().then(response => {
          try {
            let x_axis = [];
            let data = [];
            this.monthYearCountsTuple.forEach(item => {
              x_axis.push(this.MONTHS[item[0].substring(5,7)]);
              data.push(item[1]);
            });
  
            this.ytdRefreshesOption = {
              xAxis: {
                type: 'category',
                data: x_axis,
              },
              yAxis: {
                type: 'value',
                scale: true,
                min: 0,
                max: 250,
                name: 'Total Refreshes',
                nameLocation: 'middle',
                nameGap: 70
              },
              series: [
                {
                  data: data,
                  type: 'bar',
                },
              ],
              tooltip: {
                show: true
              }
            };
  
          } catch (error) {
            console.log(error.message)
          } finally {
            // resolve(true);
          }
    //     });
    //   });
    // });
    // return promise
  }

  getKevlar2Progress() {
    const promise = new Promise((resolve) => {
      this.metricsService.getKevlar2Progress().then(response => {
        response.toPromise().then(response => {
          try {
            // console.log(response)
            this.all61Fs = response["message"]["all_61fs"];
            this.all61FsKevlar2 = response["message"]["all_61fs_from_kevlar2"]
            this.allMS210s = response["message"]["all_ms210s"];
            this.allMS210sKevlar2 = response["message"]["all_ms210s_from_kevlar2"]
            this.sitesRefreshed = response["message"]["sites_refreshed"];
            this.sitesRefreshed2024 = response["message"]["sites_refreshed_2024"];
            this.totalSites = response["message"]["total_sites_in_netbox"];
            this.countSitesRefreshedRemodels2023 = response["message"]["count_sites_refreshed_remodels_2023"];
            this.countSitesRefreshedRemodels2024 = response["message"]["count_sites_refreshed_remodels_2024"];
            console.log(response);
            this.getRefreshesPerMonth();
          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });
    return promise;
  }

  getSmartsheetMetrics() {
    const promise = new Promise((resolve) => {
      this.metricsService.getSmartsheetMetrics().then(response => {
        response.toPromise().then(response => {
          try {
            this.countAp63Remediations = response["message"]["count_ap63_remediations"];
          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });
    return promise;
  }

  getRefreshesPerMonth() {
    let monthYearCounts = {};

    this.sitesRefreshed.forEach(site => {
      let installDate = site["kevlar2_install_date"];
      if (installDate == null || installDate == undefined) {
        return;
      }
      // Only include refreshes from current year in chart
      if (installDate.substring(0,4) != "2024") {
        return;
      }
      let installMonthYear = installDate.substring(0,7);
      if (installMonthYear in monthYearCounts) {
        monthYearCounts[installMonthYear] += 1;
      } else {
        monthYearCounts[installMonthYear] = 1;
      }
    });

    // Create items array
    let monthYearCountsTuple = Object.keys(monthYearCounts).map(function (key) {
      return [key, monthYearCounts[key]];
    });

    console.log(monthYearCountsTuple);
    
    const monthYearSort = (a,b) => {
      const [ma,ya] = a[0].split('-').map(x=>Number(x))
      const [mb,yb] = b[0].split('-').map(x=>Number(x))
      return ya < yb ? -1 : ya > yb ? 1 : ma < mb ? -1 : ma > mb ? 1 : 0
    }
    monthYearCountsTuple.sort(monthYearSort);

    console.log("DICTIONARY:")
    console.log(monthYearCounts);
    console.log("TUPLE:");
    console.log(monthYearCountsTuple);

    this.monthYearCountsTuple = monthYearCountsTuple;
  }

  getFakeDelay() {
    const promise = new Promise((res) => {
      setTimeout(() => {
        console.log("timeout complete")
        res("p1")
      }, 3000)
    });
    return promise;
  }


  ngOnInit() {
    this.isLoading = true;
    Promise.all(
      [
        // console.log("hello!!"),
        // this.getHi(),
        this.getKevlar2Progress(),
        this.getSmartsheetMetrics()
        // this.getFakeDelay()
      ]
    ).then(() => {
        this.generateYTDRefreshesChart();
        this.isLoading = false;
    }).catch((e) => {
      console.log(e);
      console.log('Promise.all REJECTED');
      this.isLoading = false;
    });

  }


}
